<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5" style="margin-bottom:10px;">
        <el-input v-model="form.nameOrCode" size="small" placeholder="商务合同名称/编号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5" style="margin-bottom:10px;">
        <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="5" style="margin-bottom:10px;">
        <el-input v-model="form.businessPrincipal" size="small" placeholder="业务负责人" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="6" class="input-group" style="margin-bottom:10px;">
        <el-input v-model="form.contractMoneyMin" size="small" placeholder="最小合同金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <span>~</span>
        <el-input v-model="form.contractMoneyMax" size="small" placeholder="最大合同金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
      </el-col>
      <el-col :span="5" class="input-group" style="margin-bottom:10px;">
        <el-select v-model="form.statusList" size="small" placeholder="合同状态" class="w-100" multiple>
          <el-option v-for="(label, value) in contractConfig.getConfigList('status_search')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5" class="input-group" style="margin-bottom:10px;">
        <el-select v-model="form.accountType" size="small" placeholder="合同类型" class="w-100" >
          <el-option v-for="(label, value) in contractConfig.getConfigList('type_search')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="margin-bottom:10px;">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <p class="table-count">商务合同总数：{{ page.total }}条</p>
      <el-table v-loading="tableLoading" :data="tableData" size="small">
        <el-table-column label="商务合同名称" prop="name" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
            <p>{{ scope.row.code }}</p>
          </template>
        </el-table-column>
        <el-table-column label="商务合同金额" prop="money" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.money) }}
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="品牌名称" prop="brandName" align="center"></el-table-column>
        <el-table-column label="业务负责人" prop="businessPrincipal" align="center"></el-table-column>
        <el-table-column label="合同类型" prop="accountType" align="center">
          <template slot-scope="scope">
            {{scope.row.accountType?accountType[scope.row.accountType]:''}}
          </template>
        </el-table-column>
        <el-table-column label="商务合同附件" prop="path" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="lookContract(scope.row.fileDTOList)">查看合同附件</el-button>
            <!-- <a class="link" href="javascript:void(0);" @click="downloadFile(scope.row.path, scope.row.fileName)" :download="scope.row.fileName">{{ scope.row.fileName }}</a> -->
          </template>
        </el-table-column>
        <el-table-column label="回款状态" prop="returnStatus" align="center">
          <template slot-scope="scope">
            {{scope.row.returnStatus?returnStatus[scope.row.returnStatus]:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="合同状态" prop="status" align="center">
          <template slot-scope="scope">

            <p v-if="
                scope.row.status == contractConfig.Status.EndAssessFail ||
                scope.row.status == contractConfig.Status.EndAssessing||
                scope.row.status == contractConfig.Status.CloseAssessing||
                scope.row.status == contractConfig.Status.CloseAssessFail
              ">
              <!-- 进行中<br /> -->
              {{
                contractConfig.getAppointed("status", scope.row.status, "")
              }}
            </p>
            <p v-else>
              {{ contractConfig.getAppointed("status", scope.row.status, "") }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="permissions.contract_distribution" type="text" size="small" @click="
                onOpenAdminSelectModal(
                  scope.row.businessPrincipal,
                  scope.row.businessPrincipalId,
                  scope.row.id
                )
              ">分配</el-button>
            <el-button v-if="
            permissions.contract_edit&&(
                scope.row.status == contractConfig.Status.Processing ||
                scope.row.status == contractConfig.Status.EndAssessFail ||
                scope.row.status == contractConfig.Status.CloseAssessFail||
                scope.row.status== contractConfig.Status.Starting||
                scope.row.status== contractConfig.Status.FailStarting)
              " type="text" size="small" @click="toEdit(scope.row.id)">编辑</el-button>
            <el-button v-if="  permissions.contract_show" type="text" size="small" @click="toShow(scope.row.id)">查看</el-button>
            <el-button type="text" size="small" @click='goel(scope.row.id)'>认领回款</el-button>
            <el-button v-if="
             permissions.contract_end&&(
                scope.row.status == contractConfig.Status.Processing ||
                scope.row.status == contractConfig.Status.EndAssessFail ||
                scope.row.status == contractConfig.Status.CloseAssessFail)
              " type="text" size="small" @click="onEnd(scope.row.id, scope.row.isCompleted)">结案</el-button>
            <el-button v-if=" permissions.contract_close&&(
                scope.row.status == contractConfig.Status.Processing ||
                scope.row.status == contractConfig.Status.EndAssessFail ||
                scope.row.status == contractConfig.Status.CloseAssessFail)
              " type="text" size="small" @click="onClose(scope.row.id, scope.row.putInNum)">关闭</el-button>
            <el-button v-if="
                scope.row.status == contractConfig.Status.Closed ||
                scope.row.status == contractConfig.Status.CloseAssessing ||
                scope.row.status == contractConfig.Status.CloseAssessFail
              " type="text" size="small" @click="onShowReason('关闭原因', scope.row.closeReason)">关闭原因</el-button>
            <el-button v-if="
                scope.row.status == contractConfig.Status.Starting 
              " type="text" size="small" @click="showStart(scope.row.id)">启动审批详情</el-button>
            <el-button v-if="
                scope.row.status == contractConfig.Status.EndAssessing 
              " type="text" size="small" @click="showEnd(scope.row.id)">结案审批详情</el-button>
            <el-button v-if="
                scope.row.status == contractConfig.Status.CloseAssessing 
              " type="text" size="small" @click="showClose(scope.row.id)">关闭审批详情</el-button>
            <el-button v-if="
             permissions.contract_invoice&&(
                scope.row.status == contractConfig.Status.Processing ||
               scope.row.status== contractConfig.Status.CloseAssessFail ||
              scope.row.status==  contractConfig.Status.EndAssessFail)&&scope.row.accountType==1
              " type="text" size="small" @click="toInvoice(scope.row)">申请开票</el-button>

            <!-- <el-button v-if="
             permissions.contract_invoice&&(
                scope.row.status == contractConfig.Status.Processing ||
               scope.row.status== contractConfig.Status.CloseAssessFail ||
              scope.row.status==  contractConfig.Status.EndAssessFail)
              " type="text" size="small" @click="toInvoice(scope.row)">商务认领</el-button> -->
            
            <!--
              <el-button v-if="permissions.contract_end&&(
                scope.row.status == contractConfig.Status.Processing ||
                scope.row.status == contractConfig.Status.EndAssessFail ||
                scope.row.status == contractConfig.Status.CloseAssessFail)"
                type="text" size="small" @click="addSettlementClick(scope.row.id)">
                博主结算条件
            </el-button>
            -->
            <el-button v-if="scope.row.status == contractConfig.Status.EndAssessFail" type="text" size="small" @click="
                onShowReason('结案不通过原因', scope.row.finishFailReason)
              ">结案不通过原因</el-button>
            <el-button v-if="scope.row.status == contractConfig.Status.FailStarting" type="text" size="small" @click="
                onShowReason('启动不通过原因', scope.row.startFailReason)
              ">启动不通过原因</el-button>
            <el-button v-if=" permissions.contract_reSubmit&&(scope.row.status == contractConfig.Status.FailStarting)" type="text" size="small" @click="
                reSubmit( scope.row.id)
              ">重新提交</el-button>
            <el-button v-if="scope.row.status == contractConfig.Status.CloseAssessFail" type="text" size="small" @click="onShowReason('关闭不通过原因', scope.row.closeFailReason)">关闭不通过原因</el-button>
            <el-button type="text" size="small" @click="DistributionHistory(scope.row.id)">分配历史</el-button>

            <el-button type="text" size="small" @click="toEdit(scope.row.id,'list')">附件列表</el-button>
          </template>

        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <!-- 申请开票 -->
    <el-dialog v-if="Invoicedialog" title="申请开票" :visible.sync="Invoicedialog">
      <el-form :model="InvoiceForm" ref="InvoiceForm" :rules="rules">
        <el-form-item label="客户名称" prop="customerName" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerName" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司电话" prop="companyPhone" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.companyPhone" disabled></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="companyAddress" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.companyAddress" disabled></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="taxpayerId" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.taxpayerId" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户开户行" prop="customerBank" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerBank" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户银行账号" prop="customerBankAccount" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.customerBankAccount" disabled></el-input>
        </el-form-item>
        <el-form-item label="开票金额" prop="invoiceMoney" class="block-form-item w-32">
          <el-input v-model="InvoiceForm.invoiceMoney"></el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoiceType" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.invoiceType" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceType')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable" 
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票明细" prop="invoiceDetail" class="block-form-item w-32">
          <el-select v-model="InvoiceForm.invoiceDetail" class="w-100">
            <el-option
              v-for="(item, index) in billingConfig.getConfigList('invoiceDetail')"
              :label="item.name"
              :value="parseInt(item.id)"
              :key="index"
              :disabled="!item.isEnable"
            >
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{item.name}}</div>
                <div style="margin-left:15px;">{{item.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <div style="padding-bottom:10px;">
          剩余可申请开票金额：{{ remainingMoney }}
        </div>
        <el-form-item label="开票主体" prop="finAccountId" class="block-form-item w-32" >
          <el-select v-model="InvoiceForm.finAccountId" class="w-100" disabled>
            <el-option 
              v-for="(a, index) in yhgAccountList" 
              :key="index" 
              :label="a.name" 
              :value="a.id"
              :disabled="!a.isEnable">
              <div style="display: flex;padding:0 10px;justify-content: space-between;">
                <div>{{a.name}}</div>
                <div style="margin-left:15px;">{{a.isEnable?'':'已禁用'}}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票备注" prop="remark" class="block-form-item w-99">
          <el-input maxlength="300" show-word-limit type="textarea" v-model="InvoiceForm.remark"></el-input>
        </el-form-item>
        <div class="mar-c">
          <el-button type="primary" size="small" @click="onSubmit" :disabled="submitLoading">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 业务负责人 -->
    <el-dialog title="选择业务负责人" :visible.sync="adminListModal" width="1000px" class="yhg-dialog" @open="openAdminSelectModal">
      <div class="select-con single">
        <span class="label">已选人员：</span>
        <div class="content" v-if="selectAdmin">
          <el-tag class="select-tag" closable :type="selectAdmin.username" effect="dark" @close="onAdminTagClose">
            <span class="select-tag-text">{{ selectAdmin.username }}</span>
          </el-tag>
        </div>
      </div>
      <div class="filter-con">
        <span class="label">用户搜索：</span>
        <el-input size="small" v-model="adminForm.queryString" placeholder="用户名/手机号" @keyup.enter.native="onAdminSearch"></el-input>
        <el-button class="search-btn" size="small" type="primary" @click="onAdminSearch">搜索</el-button>
      </div>
      <div class="table-con">
        <el-table :data="adminTable" v-loading="adminTableLoading" size="mini" ref="adminSelectTable">
          <el-table-column label="选择" width="55" align="center">
            <template slot-scope="scope">
              <span class="hide-label-radio">
                <el-radio v-model="selectAdminId" @change="onChangeAdmin" :label="scope.row.id"></el-radio>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="用户名" prop="username" align="center"></el-table-column>
          <el-table-column label="角色" prop="roleNameList" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.roleNameList">
                <div v-for="(item, index) in scope.row.roleNameList" :key="index">
                  {{ item }}
                </div>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="phone" align="center">
            <template slot-scope="scope">
              {{ scope.row.phone ? scope.row.phone : "--" }}
            </template>
          </el-table-column>
          <el-table-column label="邮箱" prop="email">
            <template slot-scope="scope">
              {{ scope.row.email ? scope.row.email : "--" }}
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap">
          <el-pagination background @size-change="adminSizeChange" @current-change="adminCurrentChange" :current-page.sync="adminPage.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="adminPage.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="adminPage.total">
          </el-pagination>
        </div>
      </div>
      <div class="submit-con">
        <el-button type="primary" size="small" @click="onConfirmAdminChoose">确认</el-button>
      </div>
    </el-dialog>
    <!-- 开票提示 -->
    <el-dialog title="申请开票提醒" :visible.sync="invoiceVisible" width="30%">
      <div>
        <div style="margin-bottom: 10px">开票条件：</div>
        <div class="invoiceList">
          <span>1，合同附件列表中必须已上传合同附件</span>
          <i v-if="isUploadFile" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>2，合同金额=投放记录执行价总和</span>
          <i v-if="isEqualsPrice" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>3，剩余可申请开票金额大于0</span>
          <i v-if="hasRemainingMoney" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
      </div>
    </el-dialog>
    <!-- 结案提示 -->
    <el-dialog title="结案提醒" :visible.sync="endVisible" width="40%">
      <div>
        <div style="margin-bottom: 10px">结案条件：</div>
        <div class="invoiceList">
          <span>1，合同的全部信息必须填写完整（关联框架合同&合同备注除外）</span>
          <i v-if="isContractCompleted" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>2，合同下的投放记录各字段必须填写完整</span>
          <i v-if="isPutInCompleted" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>3，合同下审核通过的开票全部已上传发票照片</span>
          <i v-if="isUploadAllInvoicePhoto" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>4，合同相关投放记录状态全部为“全部付款”</span>
          <i v-if="isPayAll" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>5，合同下的开票金额等于总合同金额</span>
          <i v-if="hasCorrectInvoiceMoney" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
         <!--
        <div class="invoiceList mt-10">
          或等于 
          <span>6，合同关联的每条投放记录，发票总额大于或等于其结算金额</span>
          <i v-if="isInvoiceMoneyGtSettlePrice" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        -->
      </div>
    </el-dialog>
    <!-- 审批详情 -->
    <el-dialog :title="approveTitle" :visible.sync="approveVisible" width="50%" v-loading="approveLoading">
      
      <div v-if="approve==1">
        <approve-contract-end-member :approveObj="approveObj" :auditStatus="auditStatus" class="mb-10"></approve-contract-end-member>
      </div>
      <div v-else>
        <approve-contract-member :approveObj="approveObj" :auditStatus="auditStatus" class="mb-10"></approve-contract-member>
      </div>
      
      
      
      <div class="mb-10">审批备注：{{auditRemark}}</div>
    </el-dialog>
    <!-- 合同附件 -->
    <el-dialog title="查看合同附件" width="40%" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column align="center" property="date" label="合同附件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.fileList" :modalShow="false"></filePreview>
          </template>
        </el-table-column>
        <el-table-column align="center" property="sealType" label="盖章类型">
          <template slot-scope="scope">
            {{sealType[scope.row.sealType]}}
          </template>
        </el-table-column>
        <el-table-column align="center" property="date" label="盖章状态">
          <template slot-scope="scope">
            {{sealStatus[scope.row.sealStatus]}}
          </template>
        </el-table-column>
        <el-table-column align="center" property="name" label="合同扫描件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.scannedCopyList" :modalShow="false"></filePreview>
            <!-- <div v-for="(item,index) in scope.row.scannedCopyList" :key="index">
              <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.name">{{ item.name }}</a>
            </div> -->
        </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 
    <el-dialog
      title="博主结算条件录入"
      :visible.sync="settlementVisible"
      width="30%"
      @close="settlementClose">
      <div class="orderBox" style="padding:20px 0;">
        <div style="width:100px;">博主结算条件</div>
        <el-input maxlength="300" show-word-limit type="textarea" placeholder="请输入博主结算条件" v-model="settlementConditions"></el-input>
      </div>
      <div style="text-align:center;margin-top:10px;">
        <el-button type="primary" @click="saveSettlementClick">确 定</el-button>
      </div>
    </el-dialog>
    -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import validate from "@/util/validate";
import util from "@/util/util";
import { contractConfig } from "@/const/config/contract";
import InvoiceFormFields from "@/const/form/InvoiceForm";
import { billingConfig,billingShow } from "@/const/config/billing";
import {
  listContract,
  endContract,
  closeContract,
  listAdmin,
  bussinessHistory,
  editAdmin,
  isInvoice,
  InvoiceAdd,
  reapply,
  getFinAccount,
  saveSettlement
} from "@/api/business/contract";
import { processList } from "@/api/approve/contract";
import approveContractMember from "@/components/common/approveContractMember";
import approveContractEndMember from "@/components/common/approveContractEndMember";
export default {
  components: {
    approveContractMember,
    approveContractEndMember,
  },
  data() {
    // 开票金额判断
    var validPrice = (rule, value, callback) => {
      let money = this.remainingMoney;
      if (!validate.checkNull(value)) {
        let err = validate.checkAmount(value, money);
        if (err) {
          callback(new Error(err));
        }
        callback();
      }
      callback();
    };
    return {
      billingShow,
      sealType:['不盖章','公章','合同章'],
      sealStatus:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
      dialogTableVisible:false,
      returnStatus:['','未回款','部分回款','全部回款'],
      accountType:['','商务开票合同（非统一开票）','博主挂靠平台单（统一商务运营开票）','代下报备平台单（统一商务运营开票）','客户自下平台单（统一商务运营开票）'],
      gridData: [],
      billingConfig,
      /**
       * 审批详情
       */
      approveVisible: false,
      approve:"",
      approveTag: "" ,
      approveTitle: "",
      approveObj: {},
      auditStatus: null,
      auditRemark: "",
      approveLoading: false,
      /**
       * 结案提醒模块
       */
      endVisible: false, //结案提醒弹窗

      isContractCompleted: false, //全部填写完整1
      isPutInCompleted: false, //投放记录表填写完整2
      isUploadAllInvoicePhoto: false, //开票全部上传照片3
      isPayAll: false, //是否全部付款4
      hasCorrectInvoiceMoney: false, //开票金额等于总合同金额5
      isInvoiceMoneyGtSettlePrice: false, //发票总额都要大于该条投放记录的结算金额6
      /**
       * 开票提醒模块
       */
      isUploadFile: false, //是否上传
      // hasCorrectIncome: false, //KOL收入+有花果收入=净收入
      isEqualsPrice:"" ,
      hasRemainingMoney: false, //剩余金额大于可开票金额
      invoiceVisible: false, //不可开票提示弹窗
      Invoicedialog: false, //开票弹窗
      remainingMoney: 100, //剩余可开票金额
      contractConfig: contractConfig,
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        statusList: "",
        accountType: "",
        businessPrincipal:"",
      },
      InvoiceForm: {
        contractId: null, //合同ID
        customerName: "", //名称
        companyPhone: "", //电话
        companyAddress: "", //公司地址
        taxpayerId: "", //纳税人识别号
        customerBank: "", //客户开户行
        customerBankAccount: "", //客户银行账户
        invoiceMoney: "", //开票金额
        invoiceType: "", //发票类型
        invoiceDetail: "", //开票明细
        remark: "", //合同备注
        finAccountId:"",
      },
      rules: {
        invoiceMoney: [
          { required: true, message: "请输入合同金额", trigger: "blur" },
          { validator: validPrice, trigger: "blur" },
        ],
        finAccountId:[
          { required: true, message: "请选择开票主体", trigger: "change" },
        ],
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      submitLoading: false,
      tableData: [],
      tableLoading: false,
      /**
       * 业务负责人模块
       */
      adminListModal: false,
      adminPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      adminForm: {
        queryString: "",
      },
      selectAdminId: null,
      selectAdmin: null,
      adminTable: [],
      adminTableLoading: false,
      pid: null,
      yhgAccountList:[],
      settlementVisible:false,//博主结算弹窗
      settlementConditions:"",//博主结算条件录入
      settlementId:"" ,
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
  methods: {
    //获取有花果账户列表
    getYhgAccount() {
      getFinAccount({type:0})
        .then((res) => {
          this.yhgAccountList = res.data || [];
        })
        .catch((err) => {
          this.yhgAccountList = [];
        });
    },
    lookContract(data){
      this.gridData = data;
      this.dialogTableVisible = true;
    },
    /**重新提交 */
    reSubmit(contractId) {
      this.$confirm("确认重新提交启动审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reapply({ contractId }).then((res) => {
            this.$message.success("重新提交成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 业务负责人模块
     */
    //打开资源选择弹窗
    onOpenAdminSelectModal(username, id, pid) {
      if (username) {
        this.selectAdmin = {
          username,
          id,
        };
      } else {
        this.selectAdmin = null;
      }
      this.pid = pid;
      this.adminListModal = true;
    },
    //资源选择弹窗打开
    openAdminSelectModal() {
      this.adminForm.queryString = "";
      this.selectAdminId = null;
      this.onAdminSearch();
    },
    //资源标签删除
    onAdminTagClose() {
      this.selectAdmin = null;
      this.selectAdminId = null;
    },
    //资源弹窗关闭
    onConfirmAdminChoose() {
      if (this.selectAdmin) {
        let obj = {
          businessPrincipalId: this.selectAdmin.id,
          contractId: this.pid,
        };
        editAdmin(obj)
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("分配成功！");
              this.getList();
            }
          })
          .catch((err) => {});
        this.adminListModal = false;
      } else {
        this.$message.error("不能删除业务负责人！");
      }
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    adminSizeChange(val) {
      this.adminPage.pageNum = 1;
      this.adminPage.pageSize = val;
      this.getAdminList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    adminCurrentChange(val) {
      this.adminPage.pageNum = val;
      this.getAdminList();
    },
    //资源搜索
    onAdminSearch() {
      this.adminPage.pageNum = 1;
      this.getAdminList();
    },
    //获取资源列表
    getAdminList() {
      let obj = {
        pageSize: this.adminPage.pageSize,
        pageNum: this.adminPage.pageNum,
      };
      if (this.adminForm.queryString && this.adminForm.queryString.trim()) {
        obj.usernameOrPhone = this.adminForm.queryString.trim();
      }
      this.adminTableLoading = true;
      listAdmin(obj)
        .then((res) => {
          this.adminTable = res.data || [];
          this.adminPage.total = res.total;
          this.adminTableLoading = false;
        })
        .catch((err) => {
          this.adminTable = [];
          this.adminPage.total = 0;
          this.adminTableLoading = false;
        });
    },
    //资源选择变化
    onChangeAdmin(val) {
      console.log(this.selectAdminId);
      this.selectAdmin = this.adminTable.find((v) => v.id == val);
    },
    /**
     * 分配历史
     */
    async DistributionHistory(contractId) {
      let obj = {
        contractId,
      };
      let str = "";
      let { data } = await bussinessHistory(obj);
      data.forEach((r) => {
        str =
          str +
          `<p>${r.createTime} ${r.createUserName}将业务负责人分配给 ${r.businessPrincipal}</p>`;
      });
      this.$alert(str, "分配历史", {
        showConfirmButton: false,
        closeOnClickModal: true,
        dangerouslyUseHTMLString: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 申请开票
     */
    // 打开开票
    async toInvoice(obj) {
      // invoiceVisible 不可开票提示弹窗
      // Invoicedialog 开票弹窗
      let res = await isInvoice({ contractId: obj.id });
      if (res.code == 1) {
        this.isUploadFile = res.data.isUploadFile;
        // this.hasCorrectIncome = res.data.hasCorrectIncome;
        this.hasRemainingMoney = res.data.hasRemainingMoney;
        this.remainingMoney = res.data.remainingMoney;
        this.isEqualsPrice = res.data.isEqualsPrice ;
      }
      if (
        this.isUploadFile &&
        //this.hasCorrectIncome &&
        this.hasRemainingMoney &&
        this.isEqualsPrice
      ) {
        this.Invoicedialog = true;
        this.invoiceVisible = false;
        console.log("async toInvoice====",obj)
        this.InvoiceForm = obj;
        this.InvoiceForm.contractId = obj.id;
        this.InvoiceForm.finAccountId = obj.yhgBankAccount;
        this.getYhgAccount()
      } else {
        this.Invoicedialog = false;
        this.invoiceVisible = true;
      }
    },
    //提交
    onSubmit() {
      this.submitLoading = true ;
      this.$refs.InvoiceForm.validate((valid, obj) => {
        if (valid) {
          let f = util.deepClone(this.InvoiceForm);
          InvoiceAdd(f).then((res) => {
            if (res.code == 1) {
              this.$message.success("申请成功！");
              this.Invoicedialog = false;
              this.submitLoading = false ;
              this.getList();
            }
          });
        } else {
          let a = Object.keys(obj).map((v) => {
            let text = "";
            if (!InvoiceFormFields.list[v] && v.lastIndexOf(".") !== -1) {
              let fieldInArray = v.substring(v.lastIndexOf(".") + 1, v.length);
              text = InvoiceFormFields.list[fieldInArray];
            } else {
              text = InvoiceFormFields.list[v];
            }
            return text;
          });
          this.submitLoading = false ;
          this.$message.error(
            "表单不完整！请检查" + a.join("、") + "是否按要求填写"
          );
        }
      });
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        statusList: "",
        accountType: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
        if (
          parseInt(this.form.contractMoneyMin) >
          parseInt(this.form.contractMoneyMax)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
       console.log("queryObj", queryObj);
      this.tableLoading = true;
      listContract(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 结案
     * @param isComplete 合同是否完整
     */
    onEnd(id, isComplete) {
      endContract(id).then((res) => {
        console.log("结案条件==========", res.data);
        if (res.code == 1) {
          if (res.data) {
            this.isContractCompleted = res.data.isContractCompleted;
            this.isPutInCompleted = res.data.isPutInCompleted;
            this.isUploadAllInvoicePhoto = res.data.isUploadAllInvoicePhoto;
            this.isPayAll = res.data.isPayAll;
            this.hasCorrectInvoiceMoney = res.data.hasCorrectInvoiceMoney;
            this.isInvoiceMoneyGtSettlePrice =
              res.data.isInvoiceMoneyGtSettlePrice;
          }
        }
        if (!res.data) {
          this.$message.success("已提交结案");
          this.getList();
          return;
        } else if (
          this.isContractCompleted &&
          this.isPutInCompleted &&
          this.isUploadAllInvoicePhoto &&
          this.isPayAll &&
          this.hasCorrectInvoiceMoney &&
          this.isInvoiceMoneyGtSettlePrice
        ) {
          this.endVisible = false;
        } else {
          this.endVisible = true;
        }
      });
    },
    /**
     * 关闭
     * @param recordNum 投放对象
     */
    onClose(id, recordNum) {
      let num = recordNum ? recordNum : 0;
      this.$prompt(
        `<p>当前合同下有${num}条投放记录。</p><p>关闭原因：</p>`,
        "合同关闭",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputErrorMessage: "请输入合同关闭原因",
          customClass: "msgbox",
          dangerouslyUseHTMLString: "true",
          inputValidator: function (value) {
            if (validate.checkNull(value) || validate.checkNull(value.trim())) {
              return false;
            }
            return true;
          },
        }
      )
        .then(({ value }) => {
          closeContract(id, value.trim()).then((res) => {
            if(res.data.code=="1"){
              this.$message.success("关闭成功");
              this.getList();
            }else{
              this.$message.error(res.data.msg);
              this.getList();
            }
            
          });
        })
        .catch((err) => {
          this.submitLoading = false;
        });
    },
    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "";
      this.$alert(reason, text, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },

    /**
     * 跳转到编辑页
     */
    toEdit(id,type) {
      let router = this.$router.push({
        path: "/business/contract/edit",
        query: {
          id,
          type
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 跳转到查看页
     */
    toShow(id) {
      let router = this.$router.push({
        path: "/business/contract/show",
        query: {
          id: id,
        },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 审批详情
     */
    showStart(id) {
      this.approveTitle = "启动审批详情";
      this.getprocessList(id, 2);
    },
    showClose(id) {
      this.approveTitle = "关闭审批详情";
      this.getprocessList(id, 3);
    },
    showEnd(id) {
      this.approveTitle = "结案审批详情";
      this.getprocessList(id, 4);
    },

    /**
     * 查询审批信息
     */
    getprocessList(contractId, auditType) {
      this.approveLoading = true;
      if(auditType==2){
        this.approveTag = 0 ;
      }else{
        this.approveTag = 1 ;
      }
      processList({ contractId, auditType }).then((res) => {
        if (res.code == 1) {
          let result = res.data;
          console.log("审批信息====", res.data);
          let obj = result;
          this.approveObj = obj;
          this.auditRemark = result.auditRemark;
          this.auditStatus = result.auditStatus;
          this.approveVisible = true;
          this.approveLoading = false;
        }
      });
    },

    //保存博主结算条件
    saveSettlementClick(){
      if(!this.settlementConditions){
        this.$message.error('请输入博主结算条件');
        return
      }
      saveSettlement({id:this.settlementId,settlementConditions:this.settlementConditions}).then(res=>{
        if(res.code === 1){
          this.$message.success("博主结算条件录入成功!");
          this.getList();
        }
        this.settlementVisible = false;
        console.log('====博主结算条件录入=====',res)
      })
    },
    //录入博主结算条件
    addSettlementClick(id){
      this.settlementId = id;
      this.settlementVisible = true;
    },

    //关闭博主结算条件
    settlementClose(){
      this.orderData = ""
    },

    //跳转认领
	  goel(id){
		  let router = this.$router.resolve({
		    path: "/business/contract/backMoney",
		    query: {
		      id: id,
		    },
		  });
		  window.open(router.href, "_blank");
	  },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    Invoicedialog(val) {
      if (!val) {
        this.InvoiceForm = {
          contractId: null, //合同ID
          customerName: "", //名称
          companyPhone: "", //电话
          companyAddress: "", //公司地址
          taxpayerId: "", //纳税人识别号
          customerBank: "", //客户开户行
          customerBankAccount: "", //客户银行账户
          invoiceMoney: "", //开票金额
          invoiceType: "", //发票类型
          invoiceDetail: "", //开票明细
          remark: "", //合同备注
        };
        this.$refs.InvoiceForm.clearValidate("invoiceMoney");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chaochu{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.mar-c {
  display: flex;
  justify-content: center;
}
.table-count {
  margin: 15px 0 10px;
}
// 列表item
.block-form-item {
  &.w-32 {
    display: inline-block;
    width: 32%;
    margin-right: 1%;
    min-height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
}
.yhg-dialog {
  .select-con {
    display: flex;
    .label {
      white-space: nowrap;
    }
    .select-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .select-tag-text {
      display: inline-block;
      max-width: 86px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .filter-con {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 800px;
    .label {
      white-space: nowrap;
    }
    .search-btn {
      margin-left: 15px;
    }
  }
  .submit-con {
    margin-top: 20px;
    text-align: right;
  }
}
.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 32px;
    height: 32px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      left: -1px;
      font-size: 33px !important;
    }
    cursor: pointer;
  }
}
.select-con {
  .el-tag .el-icon-close {
    top: -8px;
  }
}
.avue-view .cost-table {
  width: calc(50% + 100px);
  th {
    background: none;
    font-weight: normal;
    font-size: 14px;
  }
  .cell {
    padding-left: 0;
  }
}
.el-table .operate-column {
  vertical-align: text-top;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}
.orderBox{
  display: flex;
  align-items: center;
}
</style>